import React from 'react'
import IntlProviderWrapper from './IntlProviderWrapper'

function PublicLayout ({ children }) {
  return (
    <IntlProviderWrapper locale='en'>
      {children}
    </IntlProviderWrapper>
  )
}

export default PublicLayout
